import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Frappe from 'frappe-charts/dist/frappe-charts.min.esm'

class Chart extends Component {
  componentDidMount() {
    const {
      title,
      data,
      type = 'bar',
      height = 250,
      onSelect,
      start,
      ...rest
    } = this.props
    this.c = new Frappe({
      parent: this.chart,
      title,
      data,
      type,
      height,
      start,
      is_navigable: !!onSelect,
      ...rest
    })
    if (onSelect) {
      this.c.parent.addEventListener('data-select', onSelect)
    }
  }
  componentWillReceiveProps(props) {

    if (this.c.type === 'heatmap') {

      const {
        title,
        data,
        type = 'bar',
        height = 250,
        onSelect,
        start,
        end,
        ...rest
      } = this.props
      
      this.c = new Frappe({
        parent: this.chart,
        data:  props.data,
        type: 'heatmap',
        legend_scale:  props.legend_scale,
        height:   props.height,
        discrete_domains:   props.discrete_domains ,
        start: props.start ,
        end: props.end
      });

      return;
    }

    this.c.update_values(props.data.datasets, props.data.labels)
  }
  render() {
    return <div ref={chart => (this.chart = chart)} />
  }
}

export default Chart


// WEBPACK FOOTER //
// ./src/components/chart.js